import { render, staticRenderFns } from "./EconomicReport.vue?vue&type=template&id=653b755e&scoped=true&"
import script from "./EconomicReport.vue?vue&type=script&lang=js&"
export * from "./EconomicReport.vue?vue&type=script&lang=js&"
import style0 from "./EconomicReport.vue?vue&type=style&index=0&id=653b755e&lang=scss&scoped=true&"
import style1 from "./EconomicReport.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653b755e",
  null
  
)

export default component.exports